var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.77,
    height: 69.43,
    viewBox: "0 0 87.77 69.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,69.43H10.05c-.46,0-.82-.37-.82-.82V16.86c0-.46.37-.82.82-.82s.82.37.82.82v50.92h66.2V16.86c0-.46.37-.82.82-.82s.82.37.82.82v51.74c0,.46-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.55,69.43c-.46,0-.82-.37-.82-.82V16.86c0-.46.37-.82.82-.82s.82.37.82.82v51.74c0,.46-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.55,17.69c-.29,0-.56-.15-.72-.41L22.85,1.65H2.25l8.51,14.8c.23.39.09.9-.3,1.13-.39.23-.9.09-1.13-.3L.11,1.24c-.15-.26-.15-.57,0-.82S.53,0,.82,0h22.5c.3,0,.57.16.71.41l9.22,16.04c.23.39.09.9-.3,1.13-.13.07-.27.11-.41.11Z",
    fill: "red",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.72,17.69c-.14,0-.28-.04-.41-.11-.39-.23-.53-.73-.3-1.13l8.51-14.8h-20.6l-5.29,9.2c-.23.4-.73.53-1.13.3s-.53-.73-.3-1.13L63.73.41C63.88.16,64.15,0,64.45,0h22.5c.29,0,.57.16.71.41s.15.57,0,.82l-9.23,16.04c-.15.27-.43.41-.72.41Z",
    fill: "red",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.05,17.69c-.29,0-.56-.15-.72-.41L.11,1.24C-.12.84.02.34.41.11.81-.12,1.31.02,1.54.41l9.23,16.04c.23.39.09.9-.3,1.13-.13.07-.27.11-.41.11Z",
    fill: "red",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.55,17.69c-.29,0-.56-.15-.72-.41L22.61,1.24c-.23-.39-.09-.9.3-1.13.39-.23.9-.09,1.13.3l9.22,16.04c.23.39.09.9-.3,1.13-.13.07-.27.11-.41.11Z",
    fill: "red",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,17.69H16.86c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h61.04c.46,0,.82.37.82.82s-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.22,56.29c-7.48,0-13.56-6.08-13.56-13.56s6.08-13.56,13.56-13.56,13.56,6.08,13.56,13.56-6.08,13.56-13.56,13.56ZM55.22,30.83c-6.57,0-11.91,5.34-11.91,11.91s5.34,11.91,11.91,11.91,11.91-5.34,11.91-11.91-5.34-11.91-11.91-11.91Z",
    fill: "red",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.22,50.98c-.46,0-.82-.37-.82-.82v-14.55c0-.46.37-.82.82-.82s.82.37.82.82v14.55c0,.46-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5,43.71h-14.55c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h14.55c.46,0,.82.37.82.82s-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackaging);
export default __webpack_public_path__ + "static/media/packaging.d4c976674e202b6fa2cd9a2ec40c439b.svg";
export { ForwardRef as ReactComponent };